import React from "react";

// Central social / resource links + canonical public domain for SuiPads.
export const SITE_URL = "https://suipads.fun";

export const SOCIALS = {
  x: "https://x.com/suipadsfun",
  telegram: "https://t.me/suipadsfun",
  whitepaper: "/whitepaper",
};

// Turn a handle / bare domain / full URL into a working absolute link.
// kind: "twitter" | "telegram" | "website"
export function normalizeSocialUrl(kind, raw) {
  let v = (raw || "").trim();
  if (!v) return "";
  const hasScheme = /^https?:\/\//i.test(v);
  const strip = (s) => s.replace(/^@/, "").replace(/^\/+/, "");
  if (kind === "twitter") {
    if (hasScheme) return v;
    if (/(?:^|\/|\.)((?:x|twitter)\.com)(?:\/|$)/i.test(v)) return `https://${v.replace(/^\/+/, "")}`;
    return `https://x.com/${strip(v)}`;
  }
  if (kind === "telegram") {
    if (hasScheme) return v;
    if (/(?:^|\/|\.)((?:t|telegram)\.me)(?:\/|$)/i.test(v)) return `https://${v.replace(/^\/+/, "")}`;
    return `https://t.me/${strip(v)}`;
  }
  // website / anything else
  return hasScheme ? v : `https://${v.replace(/^\/+/, "")}`;
}

// X (Twitter) glyph — lucide's Twitter icon is the old bird, so use the current X mark.
export function XIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817-5.968 6.817H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" />
    </svg>
  );
}
